
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetCameraOutlined as ObiTargetCameraOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-camera-outlined.js';
 
 
 

 
 export const ObiTargetCameraOutlined = createComponent({
   react: React,
   tagName: 'obi-target-camera-outlined',
   elementClass: ObiTargetCameraOutlinedElement,
   events: {
     
   }
  });
 
 